var exports = {
  "w7": "annotation__kq01FU",
  "RI": "annotationSource__gbAgup",
  "L0": "annotationMessage__kNzqun",
};

module.exports = exports;
